module.exports = __webpack_public_path__ + "static/media/electric-tools.68d4c847.jpg";